var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView'),_c('v-idle',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"reminders":[10, 15],"wait":5,"duration":1200,"events":['click']},on:{"idle":_vm.onidle,"remind":_vm.onremind}}),(_vm.idle)?_c('idle-session',{on:{"closeModal":_vm.confirmIdle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }